import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../services/data.service";
import {Observable} from "rxjs";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  products: Observable<any>;

  constructor(private router: Router, private route: ActivatedRoute, private dataService: DataService) {
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: any) => {
      this.products = this.dataService.findProduct(params.get('se'));
    });
  }

  openProduct(product) {
    this.router.navigate(['product/' + product.id]);
  }

}
